var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCondenserOnHeaterOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Condenser_ON_Heater_OFF",
    "data-name": "Condenser ON_Heater OFF",
    xmlns: "http://www.w3.org/2000/svg",
    width: 91,
    height: 33,
    viewBox: "0 0 91 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9827",
    "data-name": "Group 9827"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3874",
    "data-name": "Path 3874",
    d: "M90.35,16.51H86.6V4.59A3.941,3.941,0,0,0,82.66.65H9.27A3.935,3.935,0,0,0,5.33,4.59V16.52H.65v9.21H5.33v2.69a3.941,3.941,0,0,0,3.94,3.94H82.66a3.935,3.935,0,0,0,3.94-3.94V25.73h3.75V16.51Z",
    fill: "#404041"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3875",
    "data-name": "Path 3875",
    d: "M82.66,33H9.27a4.6,4.6,0,0,1-4.59-4.59V26.37H0V15.86H4.68V4.59A4.6,4.6,0,0,1,9.27,0H82.66a4.6,4.6,0,0,1,4.59,4.59V15.87H91V26.38H87.25v2.04A4.594,4.594,0,0,1,82.66,33ZM1.3,25.08H5.98v3.34a3.3,3.3,0,0,0,3.3,3.29H82.67a3.3,3.3,0,0,0,3.3-3.29V25.08h3.75V17.16H85.97V4.59a3.3,3.3,0,0,0-3.3-3.29H9.27a3.3,3.3,0,0,0-3.3,3.29V17.16H1.3Z",
    fill: "#b6d3ff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9842",
    "data-name": "Group 9842"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9828",
    "data-name": "Group 9828"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3876",
    "data-name": "Path 3876",
    d: "M26.83,30.19V25.01a2.106,2.106,0,0,0,2.11-2.09v-.43h5.18v.43A7.287,7.287,0,0,1,26.83,30.19Z",
    fill: "#00b7ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9829",
    "data-name": "Group 9829"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3877",
    "data-name": "Path 3877",
    d: "M26.83,30.19a7.287,7.287,0,0,1-7.29-7.27V11.11h5.18V22.92a2.106,2.106,0,0,0,2.11,2.09v5.18Z",
    fill: "#00b7ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9830",
    "data-name": "Group 9830"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3878",
    "data-name": "Path 3878",
    d: "M43.52,11.35H38.34v-.43a2.106,2.106,0,0,0-2.11-2.09V3.65a7.287,7.287,0,0,1,7.29,7.27Z",
    fill: "#00b7ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9831",
    "data-name": "Group 9831"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3879",
    "data-name": "Path 3879",
    d: "M34.12,22.74H28.94V10.92a7.287,7.287,0,0,1,7.29-7.27V8.83a2.106,2.106,0,0,0-2.11,2.09Z",
    fill: "#00b7ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9832",
    "data-name": "Group 9832"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3880",
    "data-name": "Path 3880",
    d: "M45.63,30.19V25.01a2.106,2.106,0,0,0,2.11-2.09v-.43h5.18v.43A7.287,7.287,0,0,1,45.63,30.19Z",
    fill: "#00b7ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9833",
    "data-name": "Group 9833"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3881",
    "data-name": "Path 3881",
    d: "M45.63,30.19a7.287,7.287,0,0,1-7.29-7.27V10.51h5.18V22.92a2.106,2.106,0,0,0,2.11,2.09Z",
    fill: "#00b7ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9834",
    "data-name": "Group 9834"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3882",
    "data-name": "Path 3882",
    d: "M62.32,23.14H57.14V10.92a2.106,2.106,0,0,0-2.11-2.09V3.65a7.287,7.287,0,0,1,7.29,7.27Z",
    fill: "#00b7ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9835",
    "data-name": "Group 9835"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3883",
    "data-name": "Path 3883",
    d: "M52.92,23.33H47.74V10.92a7.287,7.287,0,0,1,7.29-7.27V8.83a2.106,2.106,0,0,0-2.11,2.09Z",
    fill: "#00b7ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9836",
    "data-name": "Group 9836"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3884",
    "data-name": "Path 3884",
    d: "M64.43,30.4V25.22a2.106,2.106,0,0,0,2.11-2.09V22.7h5.18v.43A7.287,7.287,0,0,1,64.43,30.4Z",
    fill: "#00b7ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9837",
    "data-name": "Group 9837"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3885",
    "data-name": "Path 3885",
    d: "M64.43,30.4a7.287,7.287,0,0,1-7.29-7.27h5.18a2.106,2.106,0,0,0,2.11,2.09Z",
    fill: "#00b7ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9838",
    "data-name": "Group 9838"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3886",
    "data-name": "Path 3886",
    d: "M81.12,31.43H75.94V11.14a2.106,2.106,0,0,0-2.11-2.09V3.87a7.287,7.287,0,0,1,7.29,7.27Z",
    fill: "#00b7ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9839",
    "data-name": "Group 9839"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3887",
    "data-name": "Path 3887",
    d: "M71.72,23.55H66.54V11.14a7.287,7.287,0,0,1,7.29-7.27V9.05a2.106,2.106,0,0,0-2.11,2.09Z",
    fill: "#00b7ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9840",
    "data-name": "Group 9840"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3888",
    "data-name": "Path 3888",
    d: "M24.72,11.35H19.54v-.43a2.106,2.106,0,0,0-2.11-2.09V3.65a7.287,7.287,0,0,1,7.29,7.27v.43Z",
    fill: "#00b7ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9841",
    "data-name": "Group 9841"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3889",
    "data-name": "Path 3889",
    d: "M15.32,31.1H10.14V10.92a7.287,7.287,0,0,1,7.29-7.27V8.83a2.106,2.106,0,0,0-2.11,2.09V31.1Z",
    fill: "#00b7ff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCondenserOnHeaterOff);
export default __webpack_public_path__ + "static/media/condenser_on_heater_off.8c141fe8cd4caa0153aba88f4c4ef4b7.svg";
export { ForwardRef as ReactComponent };